<template>
  <basic-dialog :show="show" @close="$emit('close')" maxWidth="700">
    <template v-slot:title>Share Report</template>
    <v-container pb-0>
      <v-textarea
        v-model="shareUrl"
        ref="textToCopy"
        outlined
        rows="4"
      ></v-textarea>
    </v-container>
    <v-row align="center" justify="center" v-if="false">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mx-2"
            fab
            dark
            color="cyan"
            v-bind="attrs"
            v-on="on"
            @click="copyLink"
          >
            <v-icon dark>mdi-content-copy </v-icon>
          </v-btn>
        </template>
        <span>Copy To Clipboard</span>
      </v-tooltip>
    </v-row>
    <template v-slot:actions>
      <v-btn @click="copyLink" color="primary" dark
        >Copy Link <v-icon dark right small>mdi-content-copy </v-icon></v-btn
      >
      <v-btn
        v-if="showShareWithSupplier"
        @click="onShareWithSupplier"
        color="primary"
        dark
      >
        Share With Supplier <v-icon right dark small>mdi-email</v-icon></v-btn
      >
    </template>
    <v-row v-if="debug">
      <v-col cols="12">
        {{ supplier }}
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../shared/BasicDialog.vue";
const SUPPLIER_INFO = gql`
  query supplierInfo($supplierId: ID!) {
    supplier(id: $supplierId) {
      id
      name
      accountsEmail
      email
    }
  }
`;
export default {
  name: "share-report-dialog",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    shareUrl: {
      type: String,
      default: () => "",
    },
    report: {
      type: Object,
      default: () => ({}),
    },
    filters: {
      type: Array,
      default: () => [],
    },
  },
  components: { BasicDialog },

  data() {
    return {
      debug: false,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    showShareWithSupplier() {
      return this.supplierId !== null;
    },
    supplierId() {
      const supplierFilter = this.filters.find((f) => f.name === "supplier_id");
      return supplierFilter ? supplierFilter.value : null;
    },
  },

  methods: {
    copyLink() {
      const textToCopy = this.$refs.textToCopy.$el.querySelector("textarea");
      textToCopy.select();
      document.execCommand("copy");
    },
    onShareWithSupplier() {
      this.$emit("share-with-supplier", {
        shareLink: this.shareUrl,
        message: this.shareUrl,
        email:
          this.supplier.accountsEmail.toString() != ""
            ? this.supplier.accountsEmail
            : this.supplier.email,
      });
    },
  },
  apollo: {
    supplier: {
      query: SUPPLIER_INFO,
      variables() {
        return { supplierId: this.supplierId };
      },
      skip() {
        return this.supplierId === null;
      },
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/reports/ShareReportDialog.vue